export const MODAL_RETAILER_DEBUG = "retailerDebug" as const;
export const MODAL_RETAILER_SHOW_TYCODE = "showTyCode" as const;
export const MODAL_RETAILER_EXTERNAL_QR_CODE = "retailerExternalQrCode" as const;

export type RetailerDebugModalType = {
    type: typeof MODAL_RETAILER_DEBUG;
    skipPassword?: boolean;
};

export type RetailerShowTyCodeModalType = {
    type: typeof MODAL_RETAILER_SHOW_TYCODE;
};

export type RetailerExternalQrCodeModalType = {
    type: typeof MODAL_RETAILER_EXTERNAL_QR_CODE;
    href: string;
};
